import { render, staticRenderFns } from "./DemoSimpleTableDark.vue?vue&type=template&id=344e16ba"
import script from "./DemoSimpleTableDark.vue?vue&type=script&lang=js"
export * from "./DemoSimpleTableDark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports